export default {
  page: {
    title: 'Sell Coins',
    description:
      'By enabling Selling Coins, your members can pre-purchase your Coins to use later or to gift to friends. You get upfront sales and increase your business’ Stored Value.'
  },
  pageV2: {
    title: 'Sell Coins & Gift Cards Overview',
    description:
      'By enabling the sale of coins, customers can pre-purchase your coins to use towards a future payment (or can send them as a gift). Increase your stored value and sales!'
  },
  status: {
    title: 'Status',
    tooltip:
      'This will activate or deactivate the ability of your members purchase your branded Coins'
  },
  banner: {
    description:
      '<b>Activate the selling of Coins and allow members to buy and gift your branded Coins</b><br/>Generate cash upfront, engage your members and drive more sales'
  },
  modals: {
    campaignCreated: {
      title: 'Campaign created successfully!',
      description:
        'You can share your campaign to create more exposure and attract more potential members:',
      shareTitle: 'Share your campaign',
      shareDescription: 'Let members know you’re selling Coins!',
      warning:
        '<b>Warning:</b> Only one campaign can be active at any given time. Since you have created a new one, any other will be deactivated.'
    },
    shareCampaign: {
      freeCoins: {
        title: 'Share your campaign',
        description: "Let members know you're offering"
      },
      sellingCoins: {
        title: 'Share your campaign',
        description: "Let members know you're running a Selling Coins campaign!"
      }
    },
    campaignAlreadyActive: {
      title: 'Warning',
      description:
        'Only one campaign can be active at any given time.<br />Do you want to make this the current active campaign?',
      details: 'The new campaign will replace the current one:',
      oldCampaignDetailsTitle: 'Current campaign',
      incentiveValueSuffix: '% on top of the total amount',
      incentiveValueSuffixType2: '1 Coin for $1',
      newCampaignDetailsTitle: 'New campaign',
      confirmButton: 'Confirm activation',
      secondaryButton: 'No, go back'
    },
    campaignAutomaticActivation: {
      title: 'Do you want to deactivate this campaign?',
      description:
        'By confirming, you will deactivate this campaign and the campaign created based on your Loyalty Program will replace the current one:',
      details: 'The new campaign will replace the current one:',
      oldCampaignDetailsTitle: 'Current campaign',
      incentiveValueSuffix: '% on top of the total amount',
      newCampaignDetailsTitle: 'New campaign',
      confirmButton: 'Confirm deactivation',
      secondaryButton: 'No, go back'
    },
    campaignRatioIssueActivation: {
      title: 'Sell Coins Update',
      description:
        "The Loyalty Program ratio you've chosen should match or exceed the ratio set for the Selling Coins. Please update the Selling Coins ratio accordingly.",
      details: 'Selling Coins Campaign:',
      oldCampaignDetailsTitle: 'Current campaign',
      incentiveValueSuffix: '% on top of the total amount',
      newCampaignDetailsTitle: 'New campaign',
      confirmButton: 'Next',
      secondaryButton: 'Cancel'
    },
    campaignLoyaltRatioIssue: {
      title: 'Your Selling Coins Campaign cannot be activated',
      description: `You cannot activate the "{name}" Campaign as you have configured a Loyalty Program with a higher value.<br /><br />Create a new Coin Sale Campaign with a higher value than the current Loyalty Program, allowing your members to enjoy the benefits of this new campaign.`,
      details: 'The new campaign will replace the current one:',
      oldCampaignDetailsTitle: 'Current campaign',
      incentiveValueSuffix: '% on top of the total amount',
      newCampaignDetailsTitle: 'New campaign',
      confirmButton: 'Create new campaign',
      secondaryButton: 'Cancel'
    },
    campaignDeactivation: {
      title: 'Do you want to deactivate this campaign?',
      description:
        'By confirming, you will deactivate this campaign and your members will not be able to purchase coins from this campaign.',
      confirmButton: 'Confirm deactivation',
      secondaryButton: 'No, go back'
    },
    campaignActivation: {
      title: 'Do you want to activate this campaign?',
      description:
        'By confirming, you will activate this campaign and your members will be able to purchase coins from this campaign.',
      confirmButton: 'Confirm activation',
      secondaryButton: 'No, go back'
    },
    campaignClosed: {
      title: 'This campaign is closed',
      description:
        'The end date defined for this campaign is expired. Please, try to activate another campaign or create a new one.',
      confirmButton: 'Create a new campaign',
      secondaryButton: 'Manage my campaigns'
    },
    campaignNotFound: {
      title: 'Campaign Not Found',
      description:
        'An error occurred and you can not activate this campaign. Please, try again later.',
      confirmButton: 'Contact Twism Support',
      secondaryButton: 'Try again later'
    },
    ratioAdjust: {
      title: 'Sell Coins Update',
      description:
        'Twism is updating the benefits of your Sell Coins campaign to match your Loyalty Program’s rewards rate.',
      description2:
        'Members will earn {ratio}% in Coins on top of the total amount they purchase, matching the rewards rate they receive while shopping with your business.',
      details: 'Selling Coins Campaign:',
      oldCampaignDetailsTitle: 'Current campaign',
      incentiveValueSuffix: '% on top of the total amount',
      incentiveValueSuffixType2: '1 Coin for $1',
      newCampaignDetailsTitle: 'New campaign',
      confirmButton: 'Confirm activation',
      secondaryButton: 'No, go back',
      disabled: 'Selling Coins disabled',
      migrationCompleted: 'Selling Coins updated with success'
    },
    disable: {
      title: 'Deactivate your selling Coins experience',
      description:
        'Do you want to turn off your revenue stream? Coins will no longer be sold to users, and they will not be able to buy gifts.',
      disclaimer:
        '<b>Pay attention:</b> This action only disables the selling of new Coins. Any Coins that were previously bought are still valid and available for its’ owners.'
    },
    enable: {
      title: 'Enable your members to buy your branded coins',
      description:
        'By confirming this modal your members will be able to buy and gift your coins for their friends and family.',
      payAttention:
        "<b>Pay attention:</b> Since you have an active {loyaltRatio}% loyalty rewards program, you'll be selling Coins at the same bonus amount. Or you can create a new campaign with a higher bonus percentage.",
      btnNewCampaign: 'Create a new campaign',
      btnActivate: 'Activate Sell Coins',
      disclaimer:
        '<b>Pay attention:</b> This action only disables the selling of new Coins. Any Coins that were previously bought are still valid and available for its’ owners.'
    },
    activate: {
      title: 'Activate the toggle below and start selling Coins',
      disclaimer: 'You can disable this later'
    },
    redirect: {
      title: 'Let’s head over to Stripe so we can pay you.',
      description:
        'To securely process and transfer funds to your bank account, we have partnered with Stripe. You only need to connect once.'
    },
    withdraw: {
      sendFounds: 'Send funds to account',
      changeMethod:
        'Your funds will be transferred to your configured payout account on Stripe.',
      total: 'Total payout amount',
      arrivalTime: 'Estimated arrival time is',
      standardArrival: 'Funds will be available up to 3 business days.',
      instantArrival: 'Funds will be available within minutes.',
      instantArrivalInfo:
        'You can request Instant Payouts any time, including weekends and holidays, and funds typically appear in the associated bank account within 30 minutes',
      more: 'Learn more about fees',
      balance: {
        title: 'Your current balance'
      },
      payoutFree: {
        title: 'Payout Fees'
      },
      stripeFree: {
        title: 'Stripe monthly account fee',
        description: 'Charged only in the first withdraw of each month.'
      },
      instantPayout: {
        title: 'Instant payout',
        description: 'Send funds to your bank account within minutes.'
      },
      success: {
        title: 'Your money is on the way!',
        description:
          'Your payment is being processed and should be available in up to 3 business days',
        descriptionInstantPayout:
          'Your payment is being processed and should be available within minutes'
      }
    },
    detailsPending: {
      title: 'Keep your payouts on time',
      description:
        'You can continue your withdrawal, but a quick check on Stripe details will help prevent payout delays.'
    },
    unlockWithdraw: {
      title: 'Additional information needed',
      description:
        'Your Stripe account requires additional information before payouts can continue. Please update your details to unlock withdrawals.'
    },
    btnSaveChanges: 'Save changes',
    btnPrimary: 'Confirm',
    btnSecondary: 'Cancel',
    btnWithdraw: 'Withdraw',
    btnChangeMethod: 'Change method',
    btnGoToStripe: 'Go to Stripe',
    btnGoBackToSellCoins: 'Go back to sell Coins',
    btnContinueWithdraw: 'Continue withdraw'
  },
  overview: {
    title: 'Overview',
    linkStripeDashboard: 'Go to Stripe dashboard',
    cards: {
      coins: {
        label: 'Total Coins sold',
        insight: 'from last month',
        tooltip:
          'This number represents the total lifetime amount of Coins that have been bought by members.'
      },
      withdraw: {
        label: 'Available Balance',
        insight: 'being processed',
        link: 'Purchase history',
        btn: 'Withdraw',
        tooltip:
          'Amount from Coin sales that’s still available to withdraw. Most fees already applied — small payout fee may apply.'
      },
      lifetimeEarnings: {
        label: 'Total Revenue',
        insight:
          'Earnings from Coin and Gift Card sales, with standard fees already applied.',
        tooltip:
          'Total earned from Coin and Gift Card sales. Includes withdrawn and available amounts. All standard fees already applied.'
      },
      coinsCustomers: {
        label: 'Coins in Customers’ Wallet',
        insight: 'Coins sold are still in customer wallets',
        tooltip:
          'Dollar amount corresponding to the number of coins your customers still hold in their wallets, waiting to be redeemed for future purchases.'
      },
      payout: {
        label: 'Total Withdrawn',
        insightEmpty: 'No payout processed yet',
        insightProcessed: 'Last payout',
        insightProcessing: 'being processed',
        btn: 'Payouts history',
        tooltip:
          'Amount from Coin sales that’s already been transferred to your bank. All applicable fees have been applied.',
        modal: {
          title: 'Payout History',
          tooltip: {
            title: "Your payout's status",
            status: {
              success: 'A withdrawal of funds was sent to your bank account.',
              processing: 'The transaction has not been completed yet.',
              failed: 'A transactions that has been canceled.'
            }
          }
        }
      }
    }
  },
  boostSalesOfCoinsBanner: {
    title:
      'Boost the selling of Coins by creating an incentive for your members!',
    description:
      'You can add a bonus percentage, define an end date for your <br/>campaign, and easily share on social media.',
    btn: 'Create a Selling Coins Campaign'
  },
  coinsPurchasedHistory: {
    title: 'Purchase history',
    description: 'A list of all Coins sold',
    searchPlaceholder: 'Search by name, date or amount',
    filters: {
      completed: 'Completed',
      processing: 'Processing',
      canceled: 'Canceled'
    }
  },
  campaign: {
    list: {
      headline: {
        title: 'Campaigns',
        subTitle: '(you can only have one active at a time)'
      },
      item: {
        titleLeft: 'Campaign revenue',
        share: 'Share campaign',
        link: 'Purchase history',
        auxTextLeft: 'being processed',
        titleRight: 'Campaign settings',
        auxTextRight: 'on top of the total amount',
        dateText: 'No expiration date'
      }
    },
    campaignSection: {
      heading: 'CAMPAIGN SETTING',
      description: 'Choose a name for this particular campaign.',
      inputPlaceholder: 'Christmas holiday break',
      supportText: "It won't be visible for members."
    },
    bonusSection: {
      heading: 'BONUS SETTING',
      description:
        'Drive more sales by giving your members a bonus on top of the Coins they purchase.',
      other: 'Other',
      warningBeggining: 'Are you sure? A',
      warningEnd: ' bonus looks a bit higher than usual.',
      tip:
        'Other gift card companies charge 9 - 15% per transaction. Twism only charges 5% + $0.30.'
    },
    dateSection: {
      heading: 'DATE SETTING',
      description: 'Set an end date for your campaign',
      noEndDate: 'No expiration date',
      noEndDateDesc:
        'With no end date, your campaign will operate until you deactivate it.',
      setAnEndDate: 'Set an end date',
      setAnEndDateDesc:
        'Your campaign will run till the defined end date is met or you deactivate it.'
    },
    sideBar: {
      preview: {
        title: 'App preview',
        mockup: {
          title: 'Best purchase deals'
        },
        card: {
          textStart: 'Get',
          textEnd: 'Coin bonus!'
        }
      },
      settings: {
        title: 'Campaign settings overview',
        bonusAuxText: 'on top of the total amount',
        campaignSettingsEmpty: 'Christmas holiday break'
      }
    }
  },
  emptyState: {
    title: 'Generating Stored Value',
    description:
      "Letting members pre-purchase your Coins for future use, either as gifts for their friends or for their own purchases. This boosts your upfront sales and enhances your business's Stored Value.",
    btn: 'Set up Sell Coins',
    btnBilling: 'Upgrade & Set up Sell Coins',
    learnMore: 'Learn more about Sell Coins'
  },
  revenueReports: {
    title: 'Revenue Reports',
    description:
      'Track your total coin sales, view performance by month, see how many coins are still held in customer wallets, and access detailed transaction history',
    purchaseHistorySection: {
      title: 'Purchase History',
      description: 'See detailed customer transactions from coin purchases.',
      filterLabel: 'Filter your transactions'
    },
    yourEarningsSection: {
      title: 'Your Earnings',
      description:
        'This chart shows how your revenue from coin sales has evolved over the selected period, helping you spot trends and understand your program’s performance.',
      analytics: {
        title:
          'Data is relative to your coins sales <strong>revenue</strong> within the time period selected:',
        info: {
          totalRevenue: {
            description: 'Total revenue generated',
            tooltip:
              'Total earned from Coin and Gift Card sales. Includes withdrawn and available amounts. All standard fees already applied.'
          },
          avgRevenuePerTransaction: {
            description: 'Average revenue per transaction',
            tooltip:
              'Average revenue generated from coin sales based on transactions.'
          },
          avgRevenuePerCustomer: {
            description: 'Average revenue per customer',
            tooltip:
              'Average revenue generated from coin sales based on the number of customers who purchased coins within the selected period.'
          }
        }
      }
    }
  }
};
